import React from 'react';
import PropTypes from 'prop-types';
import WorkflowJobsList from '@clients/app-builder/WorkflowJobsList';
import {
  PinIcon,
  PinIconFilled,
  ApiOffIcon,
  MessageOffIcon,
  HeadsetOffIcon,
  ServerOffIcon,
  DesktopCogIcon, DeleteIcon,
} from '@web/assets/icons';
import {Alert, Button, Card, Divider, Tooltip} from 'antd';
import {AgentContext, LinesContext, UserContext} from '@web/hooks/context';
import {useDispatch, useSelector} from 'react-redux';
import {getCollection, getDocRef, ServerTimestamp, setPath} from '@web/lib/firestore.db';
import {notifyAndTrack} from './notification';
import {api} from '@web/lib/api';
import {addJob} from '@web/lib/workflow.jobs';
import aiActions from '@web/redux/ai/actions';
import AddAppButton from './AddAppButton';
import Icon from './Icon';
import CollectionSyncButton from './CollectionSyncButton';
import LineConnector from './LineConnector';

CollectionHeader.propTypes = {
  collectionId: PropTypes.string.isRequired,
  collection: PropTypes.object,
  onClickEndpoint: PropTypes.func,
};

function CollectionHeader(props) {
  const dispatch = useDispatch();
  const [, h] = React.useContext(UserContext);
  const ctx = React.useContext(LinesContext);
  const atx = React.useContext(AgentContext);
  const collectionsPath = [ctx.basePath, "collections", props.collectionId].join("/");
  const syncError  = useSelector((state) => state.Collections[props.collectionId]?.syncError);

  const onClickPin = () => {
    setPath(collectionsPath, {
      pin: !props.collection?.pin,
      date: ServerTimestamp(),
    }, true)
    .then(() => {
      notifyAndTrack.success("Pinned");
    });
  }

  const onClickLive = () => {
    const live = !props.collection?.live;
    setPath(collectionsPath, {
      live,
      date: ServerTimestamp(),
    }, true)
    .then(() => {
      notifyAndTrack.success("Live" + live ? " ON" : " Off");
    });
  }

  const onClickSchema = () => {
    api.v2({
      path: `${h}/collections/${props.collectionId}/schema`,
      method: "POST",
      body: {}
    })
    .then((schema) => {
      console.log("Schema:", schema);
      notifyAndTrack.success("Schema generated");
    })
    .catch((error) => {
      console.error("Error generating schema:", error);
      notifyAndTrack.error("Error generating schema");
    });
  }

  const onSelectWorkflow = (data, event = "onDocumentCreated") => {
    console.log("onSelectWorkflow", data);
    addJob(
      ctx.basePath,
      "collection",
      getDocRef(data.path),
      data.app,
      event,
      getCollection([ctx.basePath, props.collectionId].join("/")),
    )
    .then(() => notifyAndTrack.success("Added Workflow", data.app?.name || data.app?.appName))
    .catch((error) => notifyAndTrack.error(error.message));
  }

  const onSelectWorkflowJob = (jobPath, job) => {
    dispatch(aiActions.setActiveApp(job.workflowPath, props.collectionId));
  }

  return <div className="space space-col">
    <div style={{width: "100%", margin: "0 auto"}}>
      <WorkflowJobsList
        source={[ctx.basePath, props.collectionId].join("/")}
        onSelectItem={onSelectWorkflowJob}
        header={
          <div className="space space-between">
            <div className="space space-center-y" style={{minWidth: "50%"}}>
              <label className="font-xl bolded capitalize">
                {props.collection?.name || props.collectionId}
              </label>
              <LineConnector />
              <div style={{minWidth: 300}} className="muted">{atx.agentId}</div>
              {/*<AddAppButton*/}
              {/*  shape="round"*/}
              {/*  size="normal"*/}
              {/*  // className="green-color icon-btn"*/}
              {/*  onSelect={onSelectWorkflow}*/}
              {/*>*/}
              {/*  Do Something*/}
              {/*</AddAppButton>*/}
            </div>
            <div/>
          </div>
        }
      />
    </div>
    <Divider className="hidden" />
    <div className="space space-center-y space-betweens">
      <div className="space space-center-y">
        {/*<Tooltip*/}
        {/*  trigger={["hover", "click"]}*/}
        {/*  title={*/}
        {/*    <Card bordered={false} className="card-simple card-is-tooltip card-rounded font-lg" style={{width: 300}}>*/}
        {/*      <div className="space space-col">*/}
        {/*      <div className="space space-center-y">*/}
        {/*        <Icon name={props.collection?.icon || 'TbFileDescription'} className="muted-icon" />*/}
        {/*        <span className="bolded muted">About </span>*/}
        {/*      </div>*/}
        {/*      {props.collection?.description || "Not available"}*/}
        {/*      </div>*/}
        {/*    </Card>*/}
        {/*  }*/}
        {/*  placement="topLeft"*/}
        {/*>*/}
        {/*  <label className="font-xl bolded">*/}
        {/*    {props.collection &&*/}
        {/*      <CollectionSyncButton collection={props.collection} />}*/}
        {/*  </label>*/}
        {/*</Tooltip>*/}
      </div>
      <div className="space space-center-y">
        <AddAppButton
          // shape="round"
          size="normal"
          className="green-color icon-btn"
          onSelect={onSelectWorkflow}
        >
          Add workflow
        </AddAppButton>
        <Button size="large" onClick={onClickPin} className="icon-btn">
          {props.collection?.pin ? <PinIconFilled /> : <PinIcon /> }
        </Button>
        <Button
          disabled={props.collection?.basePath === "/"}
          title="Live updates"
          size="large"
          className="icon-btn"
          onClick={onClickLive}
        >
          <Icon name="TbAccessPoint" className={props.collection?.live ? "green-icon" : ""} size={28} />
          <span className={`font-sm bolded${props.collection?.live ? " green-color" : ""}`}>LIVE</span>
        </Button>
        {Object.entries(props.collection?.endpoints || {})
        .filter((e) => e[1].host === "collection")
        .map((e) =>
          <Button
            key={e[0]}
            size="large"
            className="icon-btn bolded capitalize"
            onClick={() => props.onClickEndpoint({endpoint: e[0], params: e[1]})}
          >
            {e[0]}
          </Button>)}
        <Divider type="vertical" className="hidden" />
        <Button.Group size="large">
          <Button className="icon-btn"><ApiOffIcon size={26} /></Button>
          <Button className="icon-btn"><MessageOffIcon /></Button>
          <Button className="icon-btn"><HeadsetOffIcon /></Button>
          <Button className="icon-btn"><ServerOffIcon /></Button>
        </Button.Group>
        <Divider type="vertical" className="hidden" />
        <Button.Group size="large">
          <Button className="icon-btn"><DesktopCogIcon /></Button>
          <Button className="icon-btn">
            {props.collection?.defaultDisplayedFields?.length ?
            <Icon name="TbEyeCheck" /> :
            <Icon className="orange-icon" name="TbEyeExclamation" size={26} />}
          </Button>
          <Button
            className="icon-btn"
            onClick={onClickSchema}>
            {props.collection?.schema ?
              <Icon name="TbSettingsCheck" /> :
              <Icon className="orange-icon" name="TbSettingsExclamation" />}
          </Button>
        </Button.Group>
        <Button size={"large"} className="icon-btn" onClick={() => props.onClickEndpoint({
          endpoint: "reset",
          params: {host: "collection", method: "DELETE", path: "{{objectID}}", icon: "DeleteIcon", title: "Reset Collection"},
        })}><DeleteIcon /></Button>
      </div>
    </div>
    {props.collection &&
      !!syncError &&
      <Alert
        banner
        type="warning"
        className="rounded"
        closable
        message={
          <span className="ant-tag-warning">{syncError}</span>
        }/>
      }
      {/*{props.collection && !props.collection?.schema &&*/}
      {/*<Alert banner onClick={onClickSchema} type="warning" className="rounded" closable message={<span className="ant-tag-warning">Generate schema to enable live sync</span>} action={<Button ghost>Generate</Button>} />*/}
      {/*}*/}
  </div>
}

export default CollectionHeader;
